import React from 'react';
import Billing from '../../components/Billing';
import './style.scss';

const BillingPage = () =>{
    return(
        <div className='billing_page_wrapper'>
            <Billing/>
        </div>
    )
}

export default BillingPage;